var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start",class:_vm.classes,attrs:{"data-test":"loader"}},[(_vm.loading || _vm.waiting)?_c('busy',_vm._b({},'busy',_vm.$props,false)):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }